// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBasePersonInfoDto
 */
export interface IBasePersonInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IBasePersonInfoDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IBasePersonInfoDto
     */
    preferred_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBasePersonInfoDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBasePersonInfoDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IBasePersonInfoDto
     */
    preferred_email?: string;
}

/**
 * Check if a given object implements the IBasePersonInfoDto interface.
 */
export function instanceOfIBasePersonInfoDto(value: object): value is IBasePersonInfoDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function IBasePersonInfoDtoFromJSON(json: any): IBasePersonInfoDto {
    return IBasePersonInfoDtoFromJSONTyped(json, false);
}

export function IBasePersonInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBasePersonInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'preferred_name': json['preferred_name'] == null ? undefined : json['preferred_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'preferred_email': json['preferred_email'] == null ? undefined : json['preferred_email'],
    };
}

export function IBasePersonInfoDtoToJSON(json: any): IBasePersonInfoDto {
    return IBasePersonInfoDtoToJSONTyped(json, false);
}

export function IBasePersonInfoDtoToJSONTyped(value?: IBasePersonInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'preferred_name': value['preferred_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'preferred_email': value['preferred_email'],
    };
}

